module.exports = __webpack_public_path__ + "img/ic_24_team_football.c3698aa1.svg";